import { createFileRoute } from "@tanstack/react-router";

import { legalRoute } from "./legal/-components/legalRoute";

export const Route = createFileRoute("/compliance-policy")(
  legalRoute("compliance-policy")
);
